import React from 'react'

import MeetingFormatButton from '@/components/integration/nylas/scheduler/components/meetingFormatPicker/MeetingFormatButton'
import { MEETING_FORMAT_CHOICE_OPTIONS } from '@/components/integration/nylas/scheduler/constants'
import { useSchedulerConfig } from '@/components/integration/nylas/scheduler/context/SchedulerConfigContext'
import { useSchedulerSelection } from '@/components/integration/nylas/scheduler/context/SchedulerSelectionContext'
import { isMeetingFormatChoiceOffered } from '@/components/integration/nylas/scheduler/meetingFormatSelection'

interface Props {
  isBookingAsClient?: boolean
}

const MeetingFormatPicker: React.FC<Props> = ({ isBookingAsClient = true }) => {
  const { selectedFormatChoice, setSelectedFormatChoice } =
    useSchedulerSelection()
  const { availableMeetingFormats } = useSchedulerConfig()

  if (!availableMeetingFormats) {
    return null
  }

  const visibleOptions = MEETING_FORMAT_CHOICE_OPTIONS.filter((option) =>
    isMeetingFormatChoiceOffered(option.formatChoice, availableMeetingFormats),
  )

  // With a single option there's nothing to choose: the default choice
  // already resolves to it, so skip the question.
  if (visibleOptions.length < 2) {
    return null
  }

  return (
    <div className="mb-6 flex flex-col gap-3">
      <span>
        {isBookingAsClient
          ? 'How would you like to meet?'
          : 'How would your client like to meet?'}
      </span>

      <div className="flex flex-wrap gap-2">
        {visibleOptions.map(({ formatChoice, label }) => (
          <MeetingFormatButton
            key={formatChoice}
            label={label}
            onClick={() => setSelectedFormatChoice(formatChoice)}
            isSelected={selectedFormatChoice === formatChoice}
          />
        ))}
      </div>
    </div>
  )
}

export default MeetingFormatPicker
